import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)



const router = new VueRouter({
  base: process.env.BASE_URL,
  linkActiveClass : 'active' ,
  routes
})

router.beforeEach((to, from, next) => {
  console.log(`from = ${from.path}, to = ${to.path}`)
  Vue.prototype.$utils.log(to.path);
  next() ;

})



export default router
